import { Prisma } from "@prisma/client";
import { clientSocietySelector } from "../clients/clients.vars";
import { baseProjectSelector, constructionSiteDetailsSelector } from "../constructionSites/constructionSites.vars";
import { basicFileSelector } from "../files/files.vars";
import { defaultSocietySelector } from "../societies/societies.selectors";
import { brokerSocietyBaseSelector } from "../societies/societies.vars";


export const gfaBankFinancingSelector = {
    id: true,
    amount: true,
    rate: true,
    durationInMonths: true,
} satisfies Prisma.GFABankFinancingSelect;

export const gfaOtherFinancingSelector = {
    id: true,
    financingSource: true,
    amount: true,
} satisfies Prisma.GFAOtherFinancingSelect;

export const gfaFundRaisingSelector = {
    id: true,
    name: true,
    percentage: true,
} satisfies Prisma.GFAFundRaisingSelect;

export const gfaShareholderSelector = {
    id: true,
    shareholderType: true,
    shareholderUser: {
        select: {
            id: true,
            firstname: true,
            lastname: true,
        }
    },
    shareholderSocietyId: true,
    shareholderSociety: {
        select: defaultSocietySelector
    },
    type: true,
    participationPercentage: true,
    positionInTheCompany: true,
} satisfies Prisma.GFAShareholderSelect;

export const gfaExperienceSelector = {
    id: true,
    operationName: true,
    year: true,
    salePriceTTC: true,
    progressPercentage: true,
    unsoldStockValue: true,
    marginAmount: true,
} satisfies Prisma.GFAExperienceSelect;

export const gfaAutorisationSelector = {
    id: true,
    type: true,
    number: true,
    issueDate: true,
    displayReportDateOne: true,
    displayReportDateTwo: true,
    displayReportDateThree: true,
} satisfies Prisma.GFAAutorisationSelect;

export const gfaReferenceSelector = {
    id: true,
    section: true,
    number: true,
    locality: true,
    ha: true,
    a: true,
    ca: true,
} satisfies Prisma.GFAReferenceSelect;

export const gfaFilesOnGFASelector = {
    id: true,
    label: true,
    type: true,
    file: {
        select: basicFileSelector
    }
} satisfies Prisma.FilesOnGFASelect;

export const gfaFinancingsSelector = {
    id: true,
    estimatedSalePriceHT: true,
    estimatedSalePriceTTC: true,
    costPriceHT: true,
    costPriceTTC: true,
    includingHT: true,
    includingTTC: true,
    landCostHT: true,
    landCostTTC: true,
    studiesAndTechnicalFeesHT: true,
    studiesAndTechnicalFeesTTC: true,
    constructionCostsHT: true,
    constructionCostsTTC: true,
    contingenciesHT: true,
    contingenciesTTC: true,
    developerManagementFeesHT: true,
    developerManagementFeesTTC: true,
    marketingCostsHT: true,
    marketingCostsTTC: true,
    insuranceAndMiscellaneousHT: true,
    insuranceAndMiscellaneousTTC: true,
    numberOfLots: true,
    preCommercializationAmount: true,
    preCommercializationPercentage: true,
    clearedPreCommercializationAmount: true,
    clearedPreCommercializationPercentage: true,
    contributionAmount: true,
    bankFinancings: {
        select: gfaBankFinancingSelector
    },
    otherFinancings: {
        select: gfaOtherFinancingSelector
    },
    fundRaisings: {
        select: gfaFundRaisingSelector
    }
} satisfies Prisma.GFAFinancingsSelect;

export const gfaShareholdersAndExperiencesSelector = {
    id: true,
    realEstateIsMOA: true,
    realEstateSocietyId: true,
    realEstateSociety: {
        select: clientSocietySelector
    },
    shareholders: {
        select: gfaShareholderSelector
    },
    experiences: {
        select: gfaExperienceSelector
    }
} satisfies Prisma.GFAShareholdersAndExperiencesSelect;

export const gfaAutorisationsAndReferencesSelector = {
    id: true,
    autorisations: {
        select: gfaAutorisationSelector
    },
    references: {
        select: gfaReferenceSelector
    }
} satisfies Prisma.GFAAutorisationsAndReferencesSelect;

export const gfaConstructionSiteWithDetailsSelector = {
    ...baseProjectSelector,
	constructionSiteDetails: {
		select: {
            ...constructionSiteDetailsSelector,
            projectName: true,
            operationType: true,
            processesType: true,
        },
	},
	brokerSociety: {
		select: {
			...brokerSocietyBaseSelector,
			brokerDetails: {
				select: {
					id: true,
					accessibleProduct: {
						where: {
							gfaProduct: true,
						},
						select: {
							id: true,
							name: true,
							commission: true,
							gfaProduct: true,
						},
					},
				},
			},
		},
	},
    gfaFinancingsId: true,
    gfaFinancings: {
        select: gfaFinancingsSelector
    },
    gfaShareholdersAndExperiencesId: true,
    gfaShareholdersAndExperiences: {
        select: gfaShareholdersAndExperiencesSelector
    },
    gfaAutorisationsAndReferencesId: true,
    gfaAutorisationsAndReferences: {
        select: gfaAutorisationsAndReferencesSelector
    },
    filesOnGFA: {
        select: gfaFilesOnGFASelector
    },
} satisfies Prisma.GFAConstructionSiteSelect;